import { PageHeader, Popconfirm, Select, Space, Tooltip, message, Checkbox, Card, Tag, Empty } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, InputNumberItem, SelectItem } from "../../../Components/Items";
import SelectMarcasItem from "../../../Components/SelectMarcasItem";
import { ArrowRightOutlined, DeleteOutlined } from "@ant-design/icons";
import { contarSugerenciasPendientes } from "../../../store/actions/empresa";

const { Option } = Select;

class SugerenciasRequisicion extends Component {
  state = {
    loading: false,
    todasSugerencias: [],
    todasProveedores: [],
    tarjetasSeleccionadas: new Set(),
    reasignaciones: {},
    proyectoFiltro: 0,
    marcaFiltro: undefined,
    proveedorFiltro: undefined,
    mostrarInventario: false,
    cargandoInventario: false,
    inventarioPorClave: {},
  };

  componentDidMount() {
    this.consultarSugerencias();
  }

  consultarSugerencias() {
    this.setState({ loading: true });
    axios
      .post(
        "sugerenciasRequisicion/selectSugerencias",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ todasSugerencias: res.data.sugerencias, todasProveedores: res.data.proveedores || [] });
        }
        this.setState({ loading: false });
      });
  }

  claveTarjeta(requisicionId, insumoId) {
    return `${requisicionId}:${insumoId}`;
  }

  claveInventario(proyectoId, insumoId) {
    return `${proyectoId || "null"}:${insumoId}`;
  }

  toggleInventario() {
    const mostrarInventario = !this.state.mostrarInventario;
    this.setState({ mostrarInventario });
    if (mostrarInventario) this.consultarInventarioActual();
  }

  consultarInventarioActual() {
    const refs = [...new Map(
      this.state.todasSugerencias.flatMap((s) =>
        s.insumos.map((i) => [this.claveInventario(s.proyectoId, i.insumoId), { insumoId: i.insumoId, proyectoId: s.proyectoId }])
      )
    ).values()];
    if (!refs.length) return;
    this.setState({ cargandoInventario: true });
    axios
      .post(
        "sugerenciasRequisicion/inventarioActual",
        { refs, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const inventarioPorClave = {};
          (res.data.inventarios || []).forEach((inv) => {
            inventarioPorClave[this.claveInventario(inv.proyectoId, inv.insumoId)] = inv.cantidad;
          });
          this.setState({ inventarioPorClave });
        } else {
          message.error("No se pudo consultar el inventario actual");
        }
        this.setState({ cargandoInventario: false });
      });
  }

  actualizarCantidadLocal(requisicionId, insumoId, cantidad) {
    this.setState((state) => ({
      todasSugerencias: state.todasSugerencias.map((s) => {
        if (s._id !== requisicionId) return s;
        return {
          ...s,
          insumos: s.insumos.map((i) => (i.insumoId === insumoId ? { ...i, cantidad } : i)),
        };
      }),
    }));
  }

  guardarCantidad(requisicionId, insumoId) {
    const sugerencia = this.state.todasSugerencias.find((s) => s._id === requisicionId);
    const insumo = sugerencia?.insumos.find((i) => i.insumoId === insumoId);
    if (!insumo || typeof insumo.cantidad !== "number" || isNaN(insumo.cantidad)) return;
    axios
      .post(
        "sugerenciasRequisicion/actualizarCantidad",
        { requisicionId, insumoId, cantidad: insumo.cantidad, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error("Sucedió un error y no se pudo actualizar la cantidad");
          this.consultarSugerencias();
        }
      });
  }

  descartarInsumo(requisicionId, insumoId) {
    axios
      .post(
        "sugerenciasRequisicion/quitarInsumos",
        { refs: [{ requisicionId, insumoId }], empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Insumo descartado de la sugerencia");
          this.setState((prev) => {
            const tarjetasSeleccionadas = new Set(prev.tarjetasSeleccionadas);
            tarjetasSeleccionadas.delete(this.claveTarjeta(requisicionId, insumoId));
            return { tarjetasSeleccionadas };
          });
          this.consultarSugerencias();
          this.props.contarSugerenciasPendientes({ empresaId: this.props.empresaId });
        } else {
          message.error("Sucedió un error y no se pudo descartar el insumo");
        }
      });
  }

  toggleTarjeta(clave, checked) {
    this.setState((prev) => {
      const tarjetasSeleccionadas = new Set(prev.tarjetasSeleccionadas);
      if (checked) tarjetasSeleccionadas.add(clave);
      else tarjetasSeleccionadas.delete(clave);
      return { tarjetasSeleccionadas };
    });
  }

  toggleColumna(tarjetasColumna, checked) {
    this.setState((prev) => {
      const tarjetasSeleccionadas = new Set(prev.tarjetasSeleccionadas);
      tarjetasColumna.forEach((t) => {
        if (checked) tarjetasSeleccionadas.add(t.clave);
        else tarjetasSeleccionadas.delete(t.clave);
      });
      return { tarjetasSeleccionadas };
    });
  }

  reasignarProveedor(clave, proveedorId) {
    this.setState((prev) => ({ reasignaciones: { ...prev.reasignaciones, [clave]: proveedorId } }));
  }

  construirTarjetas() {
    const { todasSugerencias, reasignaciones, proyectoFiltro, marcaFiltro, proveedorFiltro } = this.state;
    const tarjetas = [];
    todasSugerencias.forEach((s) => {
      s.insumos.forEach((i) => {
        const clave = this.claveTarjeta(s._id, i.insumoId);
        tarjetas.push({
          clave,
          requisicionId: s._id,
          insumoId: i.insumoId,
          claveInsumo: i.clave,
          descripcion: i.descripcion,
          cantidad: i.cantidad,
          marca: i.marca,
          marcaId: i.marcaId,
          proyecto: s.proyecto,
          proyectoId: s.proyectoId,
          createdAt: s.createdAt,
          proveedorId: reasignaciones[clave] || i.proveedorId || null,
          proveedorIds: i.proveedorIds || [],
          min: i.min,
          max: i.max,
        });
      });
    });
    return tarjetas.filter((t) => {
      const pasaProyecto = !proyectoFiltro || t.proyecto === proyectoFiltro;
      const pasaMarca = !marcaFiltro || t.marcaId?.toString() === marcaFiltro.toString();
      const pasaProveedor = !proveedorFiltro || t.proveedorIds.some((id) => id?.toString() === proveedorFiltro.toString());
      return pasaProyecto && pasaMarca && pasaProveedor;
    });
  }

  agruparPorProveedor(tarjetas, proveedorPorId) {
    const columnasMap = new Map();
    tarjetas.forEach((t) => {
      const key = t.proveedorId || "sin";
      if (!columnasMap.has(key)) {
        columnasMap.set(key, {
          key,
          nombre: key === "sin" ? "Sin proveedor asignado" : proveedorPorId.get(key)?.nombre || "Proveedor",
          tarjetas: [],
        });
      }
      columnasMap.get(key).tarjetas.push(t);
    });
    const columnas = [...columnasMap.values()];
    columnas.sort((a, b) => {
      if (a.key === "sin") return 1;
      if (b.key === "sin") return -1;
      return a.nombre.localeCompare(b.nombre);
    });
    return columnas;
  }

  pasarARequisicion(tarjetas) {
    if (!tarjetas.length) return message.warning("Selecciona al menos un insumo");
    const proyectosDistintos = new Set(tarjetas.map((t) => (t.proyectoId ? t.proyectoId.toString() : "sin-proyecto")));
    if (proyectosDistintos.size > 1) {
      return message.warning("Selecciona insumos de un solo proyecto para pasarlos a requisición");
    }
    const preloadedItems = tarjetas.map((t) => ({
      insumoId: t.insumoId,
      cantidad: t.cantidad,
      proveedorId: t.proveedorId || undefined,
      origenRequisicionId: t.requisicionId,
    }));
    this.props.history.push("/panel/agregarRequisicion", {
      preloadedItems,
      proyectoId: tarjetas[0].proyectoId,
    });
  }

  render() {
    const {
      tarjetasSeleccionadas, todasSugerencias, todasProveedores, proyectoFiltro, marcaFiltro, proveedorFiltro, loading,
      mostrarInventario, cargandoInventario, inventarioPorClave,
    } = this.state;
    const proyectosDisponibles = [...new Set(todasSugerencias.map((s) => s.proyecto).filter(Boolean))].sort();
    const proveedoresDisponibles = [...todasProveedores].sort((a, b) => a.nombre.localeCompare(b.nombre));
    const proveedorPorId = new Map(todasProveedores.map((p) => [p._id.toString(), p]));

    const tarjetasFiltradas = this.construirTarjetas();
    const columnas = this.agruparPorProveedor(tarjetasFiltradas, proveedorPorId);
    const tarjetasElegidasGlobal = tarjetasFiltradas.filter((t) => tarjetasSeleccionadas.has(t.clave));

    return (
      <>
        <PageHeader
          title="Sugerencias de Requisición"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              <SelectItem
                placeholder="Proyecto"
                width={200}
                value={proyectoFiltro}
                onChange={(value) => this.setState({ proyectoFiltro: value })}
                noFocusSiguiente
              >
                <Option value={0}>Todos</Option>
                {proyectosDisponibles.map((proyecto) => (
                  <Option value={proyecto} key={proyecto}>{proyecto}</Option>
                ))}
              </SelectItem>
              <SelectMarcasItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                placeholder="Marca"
                width={200}
                value={marcaFiltro}
                onChange={(value) => this.setState({ marcaFiltro: value })}
              />
              <SelectItem
                placeholder="Proveedor"
                width={200}
                value={proveedorFiltro}
                onChange={(value) => this.setState({ proveedorFiltro: value })}
                allowClear
                noFocusSiguiente
              >
                {proveedoresDisponibles.map((proveedor) => (
                  <Option value={proveedor._id} key={proveedor._id}>{proveedor.nombre}</Option>
                ))}
              </SelectItem>
              <ButtonItem
                type={mostrarInventario ? "primary" : "default"}
                loading={cargandoInventario}
                onClick={() => this.toggleInventario()}
                style={{ fontSize: "14px", padding: "6.4px 15px", height: "32px" }}
              >
                {mostrarInventario ? "Ocultar inventario actual" : "Mostrar inventario actual"}
              </ButtonItem>
              <ButtonItem
                type="primary"
                verde
                icon={<ArrowRightOutlined />}
                disabled={!tarjetasElegidasGlobal.length}
                onClick={() => this.pasarARequisicion(tarjetasElegidasGlobal)}
                style={{ fontSize: "14px", padding: "6.4px 15px", height: "32px" }}
              >
                Pasar seleccionados a Requisición
              </ButtonItem>
            </Space>
          }
        />
        <div style={{ display: "flex", gap: 12, overflowX: "auto", paddingBottom: 8, height: "calc(100vh - 200px)" }}>
          {!loading && columnas.length === 0 && (
            <Empty description="No hay sugerencias pendientes" style={{ margin: "40px auto" }} />
          )}
          {columnas.map((columna) => {
            const seleccionadasColumna = columna.tarjetas.filter((t) => tarjetasSeleccionadas.has(t.clave));
            const todasSeleccionadasColumna = columna.tarjetas.length > 0 && seleccionadasColumna.length === columna.tarjetas.length;
            return (
              <Card
                key={columna.key}
                size="small"
                title={
                  <Space size={6}>
                    <Checkbox
                      indeterminate={seleccionadasColumna.length > 0 && !todasSeleccionadasColumna}
                      checked={todasSeleccionadasColumna}
                      onChange={(e) => this.toggleColumna(columna.tarjetas, e.target.checked)}
                    />
                    <span style={{ fontSize: 13 }}>{columna.nombre}</span>
                    <Tag style={{ fontSize: 11 }}>{columna.tarjetas.length}</Tag>
                  </Space>
                }
                extra={
                  <ButtonItem
                    size="small"
                    type="primary"
                    verde
                    icon={<ArrowRightOutlined />}
                    disabled={!seleccionadasColumna.length}
                    onClick={() => this.pasarARequisicion(seleccionadasColumna)}
                  >
                    Pasar a Requisición
                  </ButtonItem>
                }
                style={{ minWidth: 380, maxWidth: 440, flex: "0 0 400px", display: "flex", flexDirection: "column", overflow: "hidden" }}
                bodyStyle={{ flex: "1 1 auto", overflowY: "auto", padding: 6, background: "#fafafa", minHeight: 0 }}
              >
                {columna.tarjetas.map((t) => {
                  const inventarioActual = mostrarInventario ? inventarioPorClave[this.claveInventario(t.proyectoId, t.insumoId)] : undefined;
                  return (
                  <Card key={t.clave} size="small" style={{ marginBottom: 5, position: "relative" }} bodyStyle={{ padding: "5px 7px" }}>
                    <Popconfirm
                      title="Seguro que quieres descartar este insumo de la sugerencia"
                      onConfirm={() => this.descartarInsumo(t.requisicionId, t.insumoId)}
                      okText="Si"
                      cancelText="No"
                    >
                      <Tooltip title="Descartar insumo" placement="top">
                        <DeleteOutlined style={{ position: "absolute", top: 6, right: 7, color: "#f5222d", cursor: "pointer", fontSize: 13 }} />
                      </Tooltip>
                    </Popconfirm>
                    <Checkbox
                      checked={tarjetasSeleccionadas.has(t.clave)}
                      onChange={(e) => this.toggleTarjeta(t.clave, e.target.checked)}
                      style={{ marginBottom: 3, alignItems: "flex-start" }}
                    >
                      <span style={{ fontSize: 11, fontWeight: 600, lineHeight: 1.2, paddingRight: 14 }}>
                        {t.claveInsumo && <span style={{ color: "#666" }}>{t.claveInsumo} - </span>}
                        {t.descripcion}
                      </span>
                    </Checkbox>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 3 }}>
                      {t.proyecto && <Tag style={{ fontSize: 10, lineHeight: "15px", margin: 0, padding: "0 4px" }}>{t.proyecto}</Tag>}
                      {t.marca && <Tag color="blue" style={{ fontSize: 10, lineHeight: "15px", margin: 0, padding: "0 4px" }}>{t.marca}</Tag>}
                      {mostrarInventario && (
                        <Tag color="purple" style={{ fontSize: 10, lineHeight: "15px", margin: 0, padding: "0 4px" }}>
                          Inv {inventarioActual !== null && inventarioActual !== undefined ? inventarioActual : "N/D"}
                        </Tag>
                      )}
                      {(t.min !== null && t.min !== undefined) && (
                        <Tag color="volcano" style={{ fontSize: 10, lineHeight: "15px", margin: 0, padding: "0 4px" }}>Mín {t.min}</Tag>
                      )}
                      {(t.max !== null && t.max !== undefined) && (
                        <Tag color="green" style={{ fontSize: 10, lineHeight: "15px", margin: 0, padding: "0 4px" }}>Máx {t.max}</Tag>
                      )}
                    </div>
                    <InputNumberItem
                      size="small"
                      min={0}
                      style={{ width: 74, fontSize: 11 }}
                      value={t.cantidad}
                      onChange={(value) => this.actualizarCantidadLocal(t.requisicionId, t.insumoId, value)}
                      onBlur={() => this.guardarCantidad(t.requisicionId, t.insumoId)}
                    />
                    {t.proveedorIds.length > 1 && (
                      <SelectItem
                        size="small"
                        width={"100%"}
                        placeholder="Cambiar proveedor"
                        value={t.proveedorId || undefined}
                        onChange={(value) => this.reasignarProveedor(t.clave, value)}
                        style={{ marginTop: 4, fontSize: 11 }}
                        noFocusSiguiente
                      >
                        {t.proveedorIds.map((pid) => (
                          <Option value={pid} key={pid}>{proveedorPorId.get(pid)?.nombre || "Proveedor"}</Option>
                        ))}
                      </SelectItem>
                    )}
                  </Card>
                  );
                })}
              </Card>
            );
          })}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps, { contarSugerenciasPendientes })(SugerenciasRequisicion);
